import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiReducerPath } from '@Enum/index';
import { customBaseQuery } from '@Utils/api/customBaseQuery';
import { extractAuthToken } from '@Utils/api/extractAuthToken';
import { getApiUrl } from '@Utils/getApiUrl';

const baseUrl = getApiUrl();

interface ChatbotResponse {
  output: {
    output: string;
  };
  metadata: {
    run_id: string;
    feedback_tokens: [];
  };
}

export const chatbotApi = createApi({
  reducerPath: ApiReducerPath.API_CHATBOT,
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getChatbotResponse: builder.mutation<ChatbotResponse, string>({
      queryFn: async (inputText, { getState }) => {
        const token = extractAuthToken(getState);
        const response = await fetch(
          `${baseUrl}/api/ai/invoke`,
          {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ input: { input: inputText } }),
          }
        );

        if (!response.ok) {
          return { error: response.statusText };
        }

        const data = await response.json();

        return { data };
      },
    }),
  }),
});
export const { useGetChatbotResponseMutation } = chatbotApi;
